import { render, staticRenderFns } from "./menu-item-roles.vue?vue&type=template&id=28926cf4&scoped=true"
import script from "./menu-item-roles.vue?vue&type=script&lang=js"
export * from "./menu-item-roles.vue?vue&type=script&lang=js"
import style0 from "./menu-item-roles.vue?vue&type=style&index=0&id=28926cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28926cf4",
  null
  
)

export default component.exports